// extracted by mini-css-extract-plugin
export default {"banner":"banner__q4LQA","googleIcon":"googleIcon__36l2S"};